import { render, staticRenderFns } from "./SoftDisclaimers.vue?vue&type=template&id=09cb6835&scoped=true&"
import script from "./SoftDisclaimers.vue?vue&type=script&lang=js&"
export * from "./SoftDisclaimers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cb6835",
  null
  
)

export default component.exports